import { useState, useEffect } from 'react';

export default function useIsMobile(breakpoint = 768) {
    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        let timeout;
        const handleResize = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setWidth(window.innerWidth), 100);
        };
        window.addEventListener('resize', handleResize);
        return () => { clearTimeout(timeout); window.removeEventListener('resize', handleResize); };
    }, []);

    return {
        isMobile: width < breakpoint,
        isTablet: width >= breakpoint && width < 1024,
        width,
    };
}
